module.exports = __webpack_public_path__ + "media/images/p+w_type_1_w-ba1c893f836b24bc0c2ee0b5e1232914.png";